const ApiConfigUrl = "https://api.beetween.com/WeaselWeb/api/jobs/application" 

export default ApiConfigUrl;